import { Toast } from 'react-bootstrap';

import type { AlgoCommandGrowlItemData } from '@/store/growl/state/index.ts';

type Props = {
  growlItem: AlgoCommandGrowlItemData;
};

export const GrowlAlgoOrder = ({ growlItem }: Props) => {
  return (
    <Toast.Header className="text-danger">
      <strong className="text-danger me-auto">
        Could not {growlItem.action} order {growlItem.tradeId}
      </strong>
    </Toast.Header>
  );
};
